const STORAGE_KEY = 'cratehackers.agentChat.openTabs';

export type PersistedAgentChatTabs = {
  openTabIds: string[];
  activeTabId: string | null;
};

export const readAgentChatTabState = (): PersistedAgentChatTabs | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PersistedAgentChatTabs>;
    if (!parsed || !Array.isArray(parsed.openTabIds)) return null;
    return {
      openTabIds: parsed.openTabIds.filter(
        (id): id is string => typeof id === 'string' && id.length > 0,
      ),
      activeTabId:
        typeof parsed.activeTabId === 'string' ? parsed.activeTabId : null,
    };
  } catch {
    return null;
  }
};

export const writeAgentChatTabState = (state: PersistedAgentChatTabs): void => {
  try {
    if (state.openTabIds.length === 0) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Quota or private mode — tab state is optional UX sugar.
  }
};

/** Drop tabs whose conversation no longer exists after a refresh. */
export const reconcileAgentChatTabState = (
  stored: PersistedAgentChatTabs,
  runIds: Set<string>,
): PersistedAgentChatTabs => {
  const openTabIds = stored.openTabIds.filter((id) => runIds.has(id));
  if (openTabIds.length === 0) {
    return { openTabIds: [], activeTabId: null };
  }

  const activeTabId =
    stored.activeTabId === null
      ? null
      : openTabIds.includes(stored.activeTabId)
        ? stored.activeTabId
        : openTabIds[0];

  return { openTabIds, activeTabId };
};
